import React, { useState, useEffect, useRef } from 'react';
import TStyles from "../styles/TestStyles.module.css";
import LoadingGif from "../images/loading.gif";

 const LoadingBlock = () => {

    return (
        <div className={TStyles.loadingDiv}>
            <div>
                <img alt="Loading" src={LoadingGif} />
            </div>
            <div>Loading</div>
        </div>
    );
}

export default LoadingBlock;